import { render, staticRenderFns } from "./GAuthPasswordUnderline.vue?vue&type=template&id=7070b480&scoped=true&"
import script from "./GAuthPasswordUnderline.vue?vue&type=script&lang=ts&"
export * from "./GAuthPasswordUnderline.vue?vue&type=script&lang=ts&"
import style0 from "./GAuthPasswordUnderline.vue?vue&type=style&index=0&id=7070b480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070b480",
  null
  
)

export default component.exports